var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCupActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1499 17V19.1",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1499 22.5H17.1499V21.5C17.1499 20.4 16.2499 19.5 15.1499 19.5H9.1499C8.0499 19.5 7.1499 20.4 7.1499 21.5V22.5V22.5Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1499 22.5H18.1499",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C8.13 16.5 5 13.37 5 9.5V6.5C5 4.29 6.79 2.5 9 2.5H15C17.21 2.5 19 4.29 19 6.5V9.5C19 13.37 15.87 16.5 12 16.5Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47004 12.1496C4.72004 11.9096 4.06004 11.4696 3.54004 10.9496C2.64004 9.94961 2.04004 8.74961 2.04004 7.34961C2.04004 5.94961 3.14004 4.84961 4.54004 4.84961H5.19004C4.99004 5.30961 4.89004 5.81961 4.89004 6.34961V9.34961C4.89004 10.3496 5.10004 11.2896 5.47004 12.1496Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5298 12.1496C19.2798 11.9096 19.9398 11.4696 20.4598 10.9496C21.3598 9.94961 21.9598 8.74961 21.9598 7.34961C21.9598 5.94961 20.8598 4.84961 19.4598 4.84961H18.8098C19.0098 5.30961 19.1098 5.81961 19.1098 6.34961V9.34961C19.1098 10.3496 18.8998 11.2896 18.5298 12.1496Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupActive);
export default __webpack_public_path__ + "static/media/cupActive.6136ce8d868947110aa5ae229e097d31.svg";
export { ForwardRef as ReactComponent };